import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Channel } from '../../../interfaces/channel.interface';
import { IconAgodaComponent } from '../icon-agoda/icon-agoda.component';
import { IconAirbnbComponent } from '../icon-airbnb/icon-airbnb.component';
import { IconBookingComponent } from '../icon-booking/icon-booking.component';
import { IconHomeawayComponent } from '../icon-homeaway/icon-homeaway.component';
import { IconSmartbnbComponent } from '../icon-smartbnb/icon-smartbnb.component';

@Component({
  standalone: true,
  selector: 'ui-icon-platform',
  templateUrl: './icon-platform.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IconAirbnbComponent,
    IconHomeawayComponent,
    IconBookingComponent,
    IconAgodaComponent,
    IconSmartbnbComponent,
  ],
})
export class IconPlatformComponent {
  @Input({ required: true }) platform: Channel = Channel.Airbnb;
  @Input() cssClass = '';
  @Input() size = 14;
  @Input() muted = false;
  @Input() white = false;

  Channel = Channel;
}
